import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { m as attach } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { F as FileUploadButton } from '../FileUpload/FileUploadButton/index-CE-KuKzM.js';

const StyledUploadButton = /*#__PURE__*/styled(FileUploadButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-14kgr2c-0"
})(["&& + div > button{display:flex;justify-content:center;align-items:center;min-height:", ";min-width:", ";height:", ";width:", ";padding:unset;> i{color:", ";}", "}"], ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.text.color.default, isMobile(css(["min-height:", ";min-width:", ";height:", ";width:", ";"], ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.controls.height.small.mobile)));
const FileAttachmentButton = ({
  id,
  onChange,
  disabled,
  acceptedAttachmentTypes,
  multiple
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'attachment-button'
  });
  const attachButtonLabel = formatMessage({
    id: 'action-attach'
  });
  return /*#__PURE__*/React__default.createElement(StyledUploadButton, {
    buttonProps: {
      ...getDataTaktAttributes(),
      title: attachButtonLabel
    },
    variant: "transparent",
    inputId: id,
    label: attachButtonLabel,
    hideLabel: true,
    icon: attach,
    onChange: onChange,
    disabled: disabled,
    multiple: multiple,
    accept: acceptedAttachmentTypes
  });
};

export { FileAttachmentButton as F };
//# sourceMappingURL=FileAttachmentButton-BJuEq9xl.js.map
